import { refuseUnported } from '../janus-engine/unported.js';
import { encounterField } from '../shared/array-types.js';

type Row = Record<string, unknown>;
const warmups = new Map<string, (encounter: Row, actorId?: string) => Promise<boolean>>();
type WarmupState = { name: string; encounterId: string; actorId?: string; at: number; endedAt?: number; state: string };
const states: WarmupState[] = [];
export function registerActionInputWarmup(name: string, wait: (encounter: Row, actorId?: string) => Promise<boolean>): void {
    warmups.set(name, async (encounter, actorId) => {
        const state: WarmupState = { name, encounterId: String(encounterField(encounter, 'encounter_id') ?? ''), actorId,
            at: Date.now(), state: 'pending' };
        states.push(state);
        if (states.length > 128) states.shift();
        try { const ok = await wait(encounter, actorId); state.state = ok ? 'ready' : 'refused'; return ok; }
        catch (error) { state.state = String(error); throw error; }
        finally { state.endedAt = Date.now(); }
    });
}
Object.assign(window, { ftActionInputWarmupState: () => states.map(state => ({ ...state })) });
/** A boundary joins its own adoption job, never another lane's preload. */
Object.assign(window, { ftAwaitActionInputWarmups: async (ids: readonly string[], actorId: string | undefined, inputs: readonly string[]): Promise<boolean> => {
    const encounters = new Set(ids.map(id => window.FateTide?.encounterCache?.get(id.toUpperCase()) as Row | undefined)
        .filter((encounter): encounter is Row => !!encounter));
    for (const encounter of encounters) {
        const results = await Promise.all(inputs.map(async name => ({ name, ok: await warmups.get(name)?.(encounter, actorId) !== false })));
        const failed = results.find(result => !result.ok);
        if (failed) { refuseUnported(`action-preload:${failed.name}-unavailable`); return false; }
    }
    return true;
} });
Object.assign(window, { ftAwaitActionInputs: async (ids: readonly string[], actorId?: string): Promise<boolean> => {
    const encounters = new Set(ids.map(id => window.FateTide?.encounterCache?.get(id.toUpperCase()) as Row | undefined)
        .filter((e): e is Row => !!e));
    for (const encounter of encounters) {
        const results = await Promise.all([...warmups].map(async ([name, wait]) => ({ name, ok: await wait(encounter, actorId) })));
        const failed = results.find(result => !result.ok);
        if (failed) { refuseUnported(`action-preload:${failed.name}-unavailable`); return false; }
    }
    return true;
} });
